"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.HeroFooter = void 0;
require("./HeroFooter.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _renderObject = require("../../util/renderObject/renderObject");
var _ActionGroups = _interopRequireDefault(require("../ActionGroups/ActionGroups"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * HeroFooter component
 * @method
 * @param {object} props - React properties passed from composition
 * @returns HeroFooter
 */
/*
 * Primary UI component for user interaction
 */
const HeroFooter = props => {
  const {
    actions,
    variant,
    alignment,
    externalAction,
    isKnockoutLink,
    style = defaultProps.style,
    types
  } = props;
  const componentClassName = (0, _classnames.default)('pal-c-HeroFooter', {
    [`pal-c-HeroFooter--${alignment}`]: alignment
  });
  if (!actions && !externalAction) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName
  }, externalAction && (0, _renderObject.renderObject)(externalAction), !externalAction && /*#__PURE__*/_react.default.createElement(_ActionGroups.default, {
    actions: actions,
    alignment: alignment,
    isKnockoutLink: isKnockoutLink,
    style: style,
    types: types,
    variant: variant
  }));
};

/**
 * Property type definitions
 * @type {object}
 * @property {object} action1 - action1 object
 * @property {object} action2 - action2 object
 * @property {string} alignment - Set the flex justification
 * @property {object} externalAction - external action object
 * @property {boolean} isKnockoutLink - knockout color for link
 * @property {string} style - string value that sets the layout the the ActionGroupDefault
 * @property {string} type - string value that sets the style variants of the buttons and links
 */
exports.HeroFooter = HeroFooter;
const propTypes = exports.propTypes = {
  /**
   * Sets the primary action (palette only, no business logic)
   */
  action1: _propTypes.default.object,
  /**
   * Sets the secondary action (palette only, no business logic)
   */
  action2: _propTypes.default.object,
  /**
   * Set the flex justification
   */
  alignment: _propTypes.default.oneOf(['left', 'right', 'center', 'between', 'around']),
  /**
   * Sets the primary action from an external source that contains business logic
   */
  externalAction: _propTypes.default.object,
  /** knockout color for link */
  isKnockoutLink: _propTypes.default.bool,
  /**
   * Sets the stylistic version of the actions
   * - **Primary Button/Secondary Button:** Sets the actions to display as the Primary Button and Secondary Button
   * - **Primary Button/Tertiary Button:** Sets the actions to display as the Primary Button and Tertiary Button
   * - **Primary Button/Primary Link:** Sets the actions to display as the Primary Button and Primary Link
   * - **Secondary Button/Primary Link:** Sets the actions to display as the Secondary Button and Primary Link
   *  - **Primary Link/Primary Link:** Sets the actions to display as two Primary Links
   * - **Arrow Link:** Sets the link to a arrow style
   */
  type: _propTypes.default.oneOf(['Primary Button/Secondary Button', 'Primary Button/Tertiary Button', 'Primary Button/Primary Link', 'Secondary Button/Primary Link', 'Primary Link/Primary Link', 'Arrow Link']),
  /**
   * Sets the layout of the actions
   * - **inline:** Sets the actions to display inline
   * - **stacked:** Sets the actions to display as block elements (flex column)
   * - **stackedFullWidth:** Sets the actions to display as block elements and also forces the buttons to the span full width of the parent container in all viewports. Links are centered but do not spand the full width.
   */
  style: _propTypes.default.oneOf(['inline', 'stacked', 'stackedFullWidth'])
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {string} style - string value that sets the layout the the ActionGroupDefault
 */
const defaultProps = exports.defaultProps = {
  style: 'inline'
};
HeroFooter.propTypes = propTypes;
var _default = exports.default = HeroFooter;